import React from 'react';
import BusinessProcessStatuses from '../../../../model/BusinessProcessStatuses';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const BusinessProcessStatusMultiSelector = ({ title, ...props }) => {
    const { options } = useEnumerableModel(BusinessProcessStatuses);
    const _title = useLabel('Status', title);
    return (<MultiselectFilter showSelectAll itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default BusinessProcessStatusMultiSelector;
